module.exports = __webpack_public_path__ + "img/diashow (3).8567802.jpg";